export default __webpack_public_path__ + "1902e5bab30389f854c15a1ad6301dc7.png";